<template>
  <div class="wc-rank-table">
    <div class="wc-rank-table__head">
      <span>#</span>
      <span>球队</span>
      <span class="stat muted">场</span>
      <span class="stat win">胜</span>
      <span class="stat draw">平</span>
      <span class="stat lose">负</span>
      <span class="stat">进</span>
      <span class="stat muted">失</span>
      <span>积分</span>
    </div>
    <div
      v-for="team in teams"
      :key="team.id"
      class="wc-rank-table__row"
      :class="{ 'is-current': String(team.id) === String(currentTeamId) }"
    >
      <span class="wc-rank-table__rank">
        <span class="wc-rank-table__badge" :class="rankClass(team.rank)">{{ team.rank }}</span>
      </span>
      <span class="wc-rank-table__team">
        <team-logo :src="team.team_logo" :name="team.team_name" />
        <span>{{ team.team_name }}</span>
      </span>
      <span class="muted">{{ played(team) }}</span>
      <span class="win">{{ team.win || 0 }}</span>
      <span class="draw">{{ team.draw || 0 }}</span>
      <span class="lose">{{ team.lose || 0 }}</span>
      <span>{{ team.goal || 0 }}</span>
      <span class="muted">{{ team.miss_goal || 0 }}</span>
      <span class="wc-rank-table__score">{{ team.score || 0 }}</span>
    </div>
  </div>
</template>

<script>
import TeamLogo from './TeamLogo.vue'

export default {
  name: 'WorldCupRankTable',
  components: { TeamLogo },
  props: {
    teams: {
      type: Array,
      default: () => []
    },
    currentTeamId: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    played (team) {
      return Number(team.win || 0) + Number(team.draw || 0) + Number(team.lose || 0)
    },
    rankClass (rank) {
      if (Number(rank) === 1) return 'is-gold'
      if (Number(rank) === 2) return 'is-silver'
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.wc-rank-table {
  overflow: hidden;
}

.wc-rank-table__head,
.wc-rank-table__row {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) repeat(6, 26px) 36px;
  column-gap: 2px;
  align-items: center;
  padding: 0 12px;
  text-align: center;
}

.wc-rank-table__head {
  height: 30px;
  color: #8a96a8;
  border-bottom: 1px solid #dce1eb;
  font-size: 11px;
  font-weight: 400;
}

.wc-rank-table__head .stat {
  font-size: 13px;
}

.wc-rank-table__row {
  height: 46px;
  color: #1a1a1a;
  font-size: 13px;
}

.wc-rank-table__row.is-current {
  background: #fff7df;
}

.wc-rank-table__row.is-current .wc-rank-table__team span:last-child {
  color: #b8880a;
  font-weight: 700;
}

.wc-rank-table__rank {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.wc-rank-table__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #111318;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
}

.wc-rank-table__team {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  text-align: left;
}

.wc-rank-table__team span:last-child {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wc-rank-table__team ::v-deep .wc-team-logo {
  width: 22px;
  height: 22px;
  flex-basis: 22px;
  line-height: 22px;
  font-size: 10px;
}

.wc-rank-table__badge.is-gold {
  color: #0a1020;
  background: #b8880a;
  font-weight: 700;
}

.wc-rank-table__badge.is-silver {
  color: #b8880a;
  background: #e8ecf5;
  font-weight: 700;
}

.wc-rank-table__score {
  color: #111318;
  font-size: 15px;
  font-weight: 800;
}

.muted {
  color: #4a5568;
}

.win,
.draw,
.lose {
  font-size: inherit;
}

.win {
  color: #16a34a;
}

.draw {
  color: #d97706;
}

.lose {
  color: #dc2626;
}

.wc-rank-table__head .win,
.wc-rank-table__head .draw,
.wc-rank-table__head .lose {
  font-weight: 400;
}
</style>
